import './Panel.css';

/* ============================================================================
   Panel — the chunky bordered surface everything sits on.

   variant: default | hot | inset | screen
     screen  = an inset CRT display (used for the article body)
     hot     = red-bordered, glowing; for anything demanding attention
     inset   = recessed well, for secondary content

   `label` prints a small pixel tag notched into the top border, which is what
   makes the whole UI read as instrument panels rather than web cards.
   ========================================================================== */

function Panel({
  children,
  variant = 'default',
  label = null,
  corner = null,
  glow = false,
  tilt = 0,
  className = '',
  as: Tag = 'div',
  style,
  ...rest
}) {
  const classes = [
    'ui-panel',
    `ui-panel--${variant}`,
    glow ? 'is-glowing' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag
      className={classes}
      style={tilt ? { '--panel-tilt': `${tilt}deg`, ...style } : style}
      {...rest}
    >
      {label && <span className="ui-panel__label">{label}</span>}
      {corner && <span className="ui-panel__corner">{corner}</span>}
      <div className="ui-panel__body">{children}</div>
    </Tag>
  );
}

export default Panel;
